import {
  makeRequired,
  repeatPasswordValidator,
} from '../../../../../OUI/Inputs';

export const passwordRepeatFieldValidator = makeRequired(repeatPasswordValidator('password'));
